import config from 'config/main';

export const django = config.general.api_base_url;
